import React from 'react';
import styled from 'styled-components';

import useBtnClickImpression from '../../../../hooks/useBtnClickImpression';

const ButtonContainer = styled.div`
  border: solid 4px white;
  width: 50px;
  height: 50px;
  color: white;
  background: rgba(63, 63, 63, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15%;
  padding: 5px;
  flex-direction: column;
  font-size: 0.8em;
  cursor: pointer;
`;

const BlackButton = ({ options = [] }: { options: string[] }) => {
  const btnClickImpression = useBtnClickImpression();
  return (
    <ButtonContainer {...btnClickImpression}>
      {options.map((option) => (
        <div key={option}>{option}</div>
      ))}
    </ButtonContainer>
  );
};

export default BlackButton;
